//
//
//
//
//
//
//
//
//
//
//
import DeviceStaticList from "./DeviceStaticList";
export default {
  components: {
    DeviceStaticList: DeviceStaticList
  },
  data: function data() {
    return {
      tabKeys: "1"
    };
  },
  created: function created() {
    this.tabKeys = "1";
  },
  computed: {},
  methods: {}
};